module.exports = __webpack_public_path__ + "img/base.015ca452.png";